import { useEffect, useState } from 'react';

export function usePWA() {
  const [prompt, setPrompt] = useState<any>(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [notifPerm, setNotifPerm] = useState<NotificationPermission>(
    'Notification' in window ? Notification.permission : 'denied'
  );
  useEffect(() => {
    const handler = (e: Event) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    if (window.matchMedia('(display-mode: standalone)').matches) setIsInstalled(true);
    const onOnline = () => setIsOnline(true); const onOffline = () => setIsOnline(false);
    window.addEventListener('online', onOnline); window.addEventListener('offline', onOffline);
    return () => { window.removeEventListener('beforeinstallprompt', handler); window.removeEventListener('online', onOnline); window.removeEventListener('offline', onOffline); };
  }, []);
  const install = async () => { if (!prompt) return; prompt.prompt(); const { outcome } = await prompt.userChoice; if (outcome === 'accepted') { setIsInstalled(true); setPrompt(null); } };
  const requestNotif = async () => { if (!('Notification' in window)) return; setNotifPerm(await Notification.requestPermission()); };
  return { isInstallable: !!prompt, isInstalled, isOnline, notifPermission: notifPerm, install, requestNotifPermission: requestNotif };
}
